var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1578238161591,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1212,
    width: 14,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M791.418 378.812l-9.314 0 0-44.708 0-1.864C780.24 183.218 659.16 64 512 64s-268.242 119.218-270.104 266.378l0 1.862 0 44.708-9.314 0c-57.746 0-104.316 46.57-104.316 104.316l0 141.572 0 143.434 0.1 0c-0.044 0.622-0.1 1.242-0.1 1.864 0 126.67 59.61 191.868 178.828 191.868l409.812 0c117.356 0 178.828-65.198 178.828-191.868L895.734 483.128C895.734 425.38 849.164 378.812 791.418 378.812zM825.882 766.062c0 92.738-33.886 130.192-117.708 130.192L315.826 896.254c-83.822 0-117.708-35.668-117.708-130.192L198.118 628.74 198.118 493.2c0-24.968 21.402-46.37 46.37-46.37l535.028 0c24.964 0 46.368 21.402 46.368 46.37L825.884 766.062zM711.832 376.948 312.168 376.948l0-39.26c0-114.208 90.358-207.004 199.83-207.004 109.474 0 199.834 92.796 199.834 205.22L711.832 376.948z",
    "p-id": 1213,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.376 799.8c20.492 0 40.982-16.766 40.982-40.982l0-96.864c18.628-13.04 31.668-35.392 31.668-59.61 0-40.982-31.668-70.788-68.924-70.788-37.254 0-68.922 33.532-68.922 70.788-1.862 24.216 9.314 48.432 26.08 59.61l0 96.864C467.394 783.034 486.022 799.8 508.376 799.8z",
    "p-id": 1214,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.6cc1c9abdceb9339c2d30d3a5c6cc778.svg";
export { ForwardRef as ReactComponent };